
const setStorage = function (key, obj) {
//   let json = JSON.stringify(obj)
  window.localStorage.setItem(key, obj)
}

const getStorage = function (key) {
  const str = window.localStorage.getItem(key)
  if (!str) {
    return null
  }
  //   return JSON.parse(str)
  return str
}

const removeStorage = function (key) {
  window.localStorage.removeItem(key)
}

const getBrowserLang = function () {
  let browserLang = navigator.language ? navigator.language : navigator.browserLanguage
  let defaultBrowserLang = ''
  if (browserLang.toLowerCase().indexOf('zh')) {
    defaultBrowserLang = 'zh'
  } else {
    defaultBrowserLang = 'pt'
  }
  return defaultBrowserLang
}

export default { setStorage, getStorage, removeStorage, getBrowserLang }
export { setStorage, getStorage, removeStorage, getBrowserLang }
